module.exports = __webpack_public_path__ + "static/media/SarahSwitek_15_ThatsAll_4.facc5c84.mp3";